import React, { useEffect, useState } from 'react'
import {
  useForm, FieldValues, SubmitHandler, Controller
} from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import Select, { SingleValue } from 'react-select';
import { ErrorMessage } from "@hookform/error-message"
import { EventCreationDetails } from '../types/eventModel';
import { EventSeriesProps as EventSeriesCalProps } from '../types/eventModel'
import { EventFullInfo, EventSeriesProps, EventSeriesCreateProps } from '../../../../models/event';
import '../styles/EventForm.css'
import { getAllVenues, GETAllVenues_Single, VenueDetails } from "../../venues/venueModels";
import { VenueMap } from '../../venues/components';
import DateTimePicker from 'react-datetime-picker';
import DatePicker from 'react-date-picker'
import TimePicker from 'react-time-picker';
import moment from 'moment';
import '../styles/TimePicker.css';
import '../styles/DatePicker.css';
import 'react-datetime-picker/dist/DateTimePicker.css';
import { fetchSeriesById, fetchUserById, fetchVenues, fetchEventAttendees } from '../../../../utils';
import { strArrayToString } from '../../../../utils/str';
import { setTimeofDateTime } from '../../../../utils/datetime';

//import { fetchEvents, localToGMT, GMTToLocalIso } from './utils'
import { localToGMT } from '../utils'
import { VenueSelector } from '../../venues/components/VenueSelector';
import privateVenueMapPlaceholder from '../files/simple-house.jpg'
import { UserInfo } from 'os';
import { UserDetails } from '../../../../models/user/userInfo';
import '../../venues/index.css'; // is this the right style sheet?
import { isValueType } from 'react-date-picker/dist/cjs/shared/propTypes';
import { MoonLoader } from 'react-spinners'
import { getVenueDetails } from '../../venues/venueModels';
import jstz from 'jstimezonedetect';
import { de } from 'date-fns/locale';
import { get } from 'jquery';






export interface eventFormProps
{
    loggedInUser?: number,
    authToken?: string,
    containerClassname?: string,
    event?: EventSeriesProps | EventFullInfo,
    onRequestEdit?: ()=>void,
    onSubmitSuccessful: () => void,
    onCancel: () => void,
    onRSVPToggle: (eid: number) => Promise<boolean>,
    readonly?: Boolean,
    disableRsvp ?: Boolean,
    noReset ?: Boolean,
}





export const EventFormModal: React.FC<eventFormProps> = (props) =>
{
    const { containerClassname, event, authToken, loggedInUser, onCancel, onRequestEdit, onRSVPToggle, readonly } = props
    const [isLoading, setIsLoading] = useState(true)
    const [formDataLoaded, setFormDataLoaded] = useState(false)
    const [venueOptions, setVenuesOptions] = useState<{label: string; value: VenueDetails}[]>([])
    const [series, setSeries] = useState<EventSeriesCalProps>()
    const [instance, setInstance] = useState<EventFullInfo>()
    const [userDetails, setUserDetails] = useState<UserDetails>()
    const [selectedVenue, setSelectedVenue] = useState<VenueDetails | undefined>()
    const [isRecurring, setIsRecurring] = useState(false)
    const [isEditingSeries, setIsEditingSeries] = useState<boolean|undefined>(false) // Are we editing an EventInfo or an EventSeriesProps?
    const [deleteConfirmDisplay, setDeleteConfirmDisplay] = useState<boolean>(false);
    const [theRSVPArray, setTheRSVPArray] = useState<string[]>([]);
    const [theRSVPString, setTheRSVPString] = useState<string>("(no RSVP's at this time)");

    const dateStringFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    var tz = jstz.determine();
    //Hardcoding for now
    const locale = 'America/New_York'



    useEffect(() => 
    {
        setIsRecurring(getValues('recurrencePattern') !== 'ONCE')
    }, [])

    //const getDateString = (d: Date) => {return (d.getFullYear() + '-' + (d.getMonth() + 1).toString().padStart(2,"0") + '-' + d.getDate().toString().padStart(2,"0"))};

    //var defaultStartDateTime = new Date("February 2, 1922 22:22:22");
    var defaultStartDateTime = new Date();
    defaultStartDateTime.setMinutes(0, 0, 0);
    //defaultStartDateTime.setHours(18);
    
    var defaultEndDateTime = new Date(defaultStartDateTime.getTime() + (60 * 60 * 1000));



  
    const defaultValues =
    {
        name: 'My Event',
        info: '',
        detailed_directions: '',
        slots: 20,
        websiteUrl: '',
        eventStartDateTime: moment(defaultStartDateTime).toISOString(),
        eventEndDateTime: moment(defaultEndDateTime).toISOString(),
        eventStartTime: moment(defaultStartDateTime).format('HH:mm'),
        eventEndTime: moment(defaultEndDateTime).format('HH:mm'),
        instanceStartDateTime: defaultStartDateTime.toISOString(),
        instanceEndDateTime: defaultEndDateTime.toISOString(),
        eventsStart: defaultStartDateTime.toISOString(),
        eventsEnd: defaultEndDateTime.toISOString(),
        venueOption:null,
        recurrencePreset: { label: 'one time only', value: {recurrencePattern:'ONCE', recurrenceSeperation:undefined}},
        recurrencePattern: 'ONCE',
        recurrenceSeperation: 0,
        lowestTableNumber: 1,
        highestTableNumber: 4,
        //session_lock: null
    }





    const
    {
        formState: { errors, isValid }, getValues, register, setValue: setFormValue, handleSubmit, control, reset
    } = useForm<FieldValues>(
        {
            defaultValues: defaultValues,
            mode: 'onBlur'
        },
    );





    const recurrenceSelectOptions =
    [
        { label: 'one time only', value: {recurrencePattern:'ONCE', recurrenceSeperation:undefined}},
        { label: 'daily', value: {recurrencePattern:'DAILY', recurrenceSeperation:0}},
        { label: 'weekly', value: {recurrencePattern:'WEEKLY', recurrenceSeperation:0}},
        { label: 'biweekly', value: {recurrencePattern:'WEEKLY', recurrenceSeperation:1}},
        { label: 'monthly', value: {recurrencePattern:'MONTHLY', recurrenceSeperation:0} },
    ]





    const isEditingSeriesSelectOptions =
    [
        { label: 'Editing event series for', value: 'true' },
        { label: 'Editing single event', value: '' } // Empty string is falsy
    ]





    const loadEventAttendees = () =>
    {
        if(event)
        {
            fetchEventAttendees(event.id).then((r) =>
            {
                if(r !== undefined)
                {
                    setTheRSVPArray(r);
                    setTheRSVPString(strArrayToString(r, ", ", "@"));
                }
                else
                {
                    console.error("[EventForm:loadEventAttendees] eventAttendees is undefined");
                }
            });
        }
    }





    const loadFormData = () =>
    {
        // Fetches list of venues, and the event owner's username
        if (authToken && loggedInUser)
        {
            setIsLoading(true);
            console.log(event);
            Promise.all([
                event ? fetchEventAttendees(event.id) : Promise.resolve([]),
                fetchVenues(authToken),
                event && (event as EventFullInfo).series_ID ? fetchSeriesById((event as EventFullInfo).series_ID!, authToken) : Promise.resolve(undefined),
                fetchUserById(loggedInUser, authToken)
            ]).then(([attendees, venues, series, userInfo]) =>
            {
                console.log(series);
                if(attendees !== undefined)
                {
                    setTheRSVPArray(attendees);
                    setTheRSVPString(strArrayToString(attendees, ", ", "@"));
                }
                else
                {
                    console.error("[EventForm:loadFormData(authToken && loggedInUser)] attendees is undefined");
                }

                setVenuesOptions(venues.map(v=>({label:v.name, value:v})));
                setSeries(series);
                setUserDetails(userInfo);
                setFormDataLoaded(true);

            }).catch((err) =>
            {
                setFormDataLoaded(false);
                console.error(`Error loading EventForm data: ${JSON.stringify(err)}`);

            }).finally(() =>
            {
                setIsLoading(false);
            });
        }
        else
        {
            setIsLoading(true)
            Promise.all([
                event ? fetchEventAttendees(event.id) : Promise.resolve([]),
                event ? getVenueDetails(event.venue) : Promise.resolve(undefined),
                event && Object.keys(event).includes('series') && (event as EventFullInfo).series_ID ? fetchSeriesById((event as EventFullInfo).series_ID!, authToken) : Promise.resolve(undefined),
            ]).then(([attendees, venue, series]) =>
            {
                console.log("[EventForm:loadFormData(authToken && loggedInUser => else)] venue:");
                console.log(venue);

                if(attendees !== undefined)
                {
                    setTheRSVPArray(attendees);
                    setTheRSVPString(strArrayToString(attendees, ", ", "@"));
                }
                else
                {
                    console.error("[EventForm:loadFormData(authToken && loggedInUser => else)] attendees is undefined");
                }

                venue && setVenuesOptions([{label: venue.name, value: venue}]);
                setSeries(series);
                setFormDataLoaded(true);

            }).catch((err) =>
            {
                setFormDataLoaded(false);
                console.error(`Error loading EventForm data: ${JSON.stringify(err)}`);

            }).finally(() =>
            {
                setIsLoading(false)
            });
        }
    }





    useEffect(() =>
    {
        loadFormData();
        console.log('[EventFormModal] loaded form data');

        if (authToken && loggedInUser)
        {

        }
        else
        {
            console.error('Creating or editing events requires event host permission.')
        }
    }, [event, authToken, loggedInUser])




  
    useEffect(() =>
    {
        // If existing event is supplied, determine if it is a series or an instance
        if (event && Object.keys(event).includes('eventsStart'))
        {
            console.log('Series Passed in')
            setSeries(event as EventSeriesCalProps)
            setIsEditingSeries(true)
        }
        else if (event)
        {
            console.log('one-off passed in')
            setInstance(event as EventFullInfo)
            console.log(event)
            setIsEditingSeries(false)
        }
    /*        else
        {
            setInstance(undefined);
            setSeries(undefined);
            setIsEditingSeries(false);
        }*/
    }, [event])





    useEffect(() =>
    {
        console.log('RUNNING');
        console.log(series);
        console.log(isEditingSeries);
        // Populate form values with existing data (if any)
        if (series && isEditingSeries)
        {
            const evtStart = series.eventsStart ? moment(series.eventsStart).toISOString() : defaultValues.eventsStart
            const evtEnd = series.eventsEnd ? moment(series.eventsEnd).toISOString(): defaultValues.eventsEnd
            console.log('SERIES INFO')
            console.log(series)
            console.log(evtStart)
            console.log(evtEnd)
            // Editing existing series
            setFormValue('highestTableNumber', series.highestTableNumber)
            setFormValue('info', series.info)
            setFormValue('lowestTableNumber', series.lowestTableNumber)
            setFormValue('name', series.name)
            setFormValue('slots', series.slots)
            const seriesVenue = venueOptions.find(o=>o.value.id === series?.venue)?.value
            setSelectedVenue(seriesVenue)
            setFormValue('venueOption', {label:seriesVenue?.name, value:seriesVenue})
            setFormValue('websiteUrl', series.websiteUrl)
            setFormValue('eventStartDateTime', moment(series.eventStartDateTime))
            setFormValue('eventEndDateTime', moment(series.eventEndDateTime))
            setFormValue('eventStartTime', series.eventStartDateTime)
            setFormValue('eventEndTime', series.eventEndDateTime)
            setFormValue('recurrencePreset', recurrenceSelectOptions.find(o=>o.value.recurrencePattern === series.recurrencePattern && o.value.recurrenceSeperation === series.recurrenceSeperation))
            setFormValue('recurrencePattern', series.recurrencePattern)
            setFormValue('recurrenceSeperation', series.recurrenceSeperation)
            setFormValue('eventsStart', evtStart)
            setFormValue('eventsEnd', evtEnd)
            setIsRecurring(!!series.recurrencePattern)
        }
        else if (instance && !isEditingSeries)
        {
            // Editing existing instance (May or may not be a part of a series.)
            console.log('[EventFormModal] Start Date Time: ' + instance.start_DateTime)
            console.log('[EventFormModal] End Date Time: ' + instance.end_DateTime)

            const startDTDate = new Date(instance.start_DateTime);
            const endDTDate = new Date(instance.end_DateTime);

            setFormValue('highest_Table_Number', instance.highest_Table_Number)
            setFormValue('info', instance.info)
            setFormValue('lowest_Table_Number', instance.lowest_Table_Number)
            setFormValue('name', instance.name)
            setFormValue('slots', instance.slots)
            const instanceVenue = venueOptions.find(o=>o.value.id === instance?.venue)?.value
            setSelectedVenue(instanceVenue)
            setFormValue('venueOption', {label: instanceVenue?.name, value:instanceVenue})
            setFormValue('website_URL', instance.website_URL)
            setFormValue('instanceStartDateTime', startDTDate)
            setFormValue('instanceEndDateTime', endDTDate)
            setFormValue('eventStartDateTime', moment(startDTDate))
            setFormValue('eventEndDateTime', moment(endDTDate))
            setFormValue('eventStartTime', moment(startDTDate).format('HH:mm'))
            setFormValue('eventEndTime', moment(endDTDate).format('HH:mm'))
            //setFormValue('session_lock', (instance.session_lock && instance.session_lock < new Date()))
        }
        else if(instance === undefined && isEditingSeries)
        {
            console.log('[EventFormModal] Modal opened to create new series');
            console.log('[EventFormModal] Start Date Time: ' + defaultValues.eventStartTime)
            console.log('[EventFormModal] End Date Time: ' + defaultValues.eventEndTime)

            //const evtStart = series.start_Date ? series.start_Date : defaultValues.eventsStart
            //const evtEnd = series.end_Date ? series.end_Date : defaultValues.eventsEnd

            //eventStartDateTime
            setFormValue('eventStartTime', defaultValues.eventStartTime);
            setFormValue('eventEndTime', defaultValues.eventEndTime);
        }
        else if(instance === undefined && !isEditingSeries)
        {
          // Editing new event, use form defaults
            console.log('[EventFormModal] Modal opened to create new one-off event (default) ');
            console.log(instance);
        }


        //TODO: Add a logic branch for the case where we know we are editing a one off event.
        // Else, creating new event, use form defaults
    }, [series, instance, isEditingSeries, venueOptions])





    const handleVenueSelect = (o:{label:string, value: VenueDetails}) =>
    {
        setSelectedVenue(o.value);
    }




    
    const handleRecurrencePatternChange = (e: any) =>
    {
        console.log('[EventFormModal] handleRecurrencePatternChange');

        setIsRecurring(e.value.recurrencePattern !== 'ONCE');
        setFormValue('recurrencePattern', e?.value.recurrencePattern);
        setFormValue('recurrenceSeperation', e?.value.recurrenceSeperation);
        const eventsStartDate = new Date(getValues('eventsStart'));

        switch (e.value.recurrencePattern)
        {
            case 'ONCE':
                handleChangeBetweenEditingInstanceOrSeries(false);
                setFormValue('eventsEnd', getValues('eventsStart'));
                break;
            case 'DAILY':
                handleChangeBetweenEditingInstanceOrSeries(true);
                const dateForNextDay = new Date(eventsStartDate.getTime() + 1 * 24 * 60 * 60 * 1000);
                setFormValue('eventsEnd', dateForNextDay.toISOString());
                break;
            case 'WEEKLY':
                handleChangeBetweenEditingInstanceOrSeries(true);
                const dateForNextWeek = new Date(eventsStartDate.getTime() + 7 * 24 * 60 * 60 * 1000);
                setFormValue('eventsEnd', dateForNextWeek.toISOString());
                break;
            case 'BIWEEKLY':
                handleChangeBetweenEditingInstanceOrSeries(true);
                const dateForTwoWeeks = new Date(eventsStartDate.getTime() + 14 * 24 * 60 * 60 * 1000);
                setFormValue('eventsEnd', dateForTwoWeeks.toISOString());
                break;
            case 'MONTHLY':
                handleChangeBetweenEditingInstanceOrSeries(true);
                const dateForNextMonthIsh = new Date(eventsStartDate.getTime() + 35 * 24 * 60 * 60 * 1000);
                setFormValue('eventsEnd', dateForNextMonthIsh.toISOString());
                break;
                
        }
    }





    const handleChangeBetweenEditingInstanceOrSeries = async (o:any) =>
    {
        console.log('[EventFormModal] handleChangeBetweenEditingInstanceOrSeries');
        console.log(o);

//        var val = o?.value;

        var val = undefined;

        if(o?.value !== undefined)
        {
            val = o?.value;
        }
        else
        {
          if(o === true || o === false)
            {
                val = o;
            }
        }

        if(val === '')
        {
            setIsEditingSeries(false);
        }
        
        if(val)
        {
            // now editing series
            await loadFormData()
            setIsEditingSeries(val)
        }
        else
        {
            // now editing instance
            setIsEditingSeries(val)
        }
    }





    const OnSubmitEvent = (requestBody:EventCreationDetails) =>
    {
        const requestOptions =
        {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        }
        console.log("[EventFormModal=>OnSubmitEvent]: requestBody = " + JSON.stringify(requestBody));

        // Convert from local date-time to GMT
        const eDetails = requestBody as EventCreationDetails //TODO: No longer necessary, refactor

        // date-time conversions no longer needed
        // const convertedStart = localToGMT(eDetails.eventsStart, eDetails.eventStartTime, 'America/New_York');
        // const convertedEnd = localToGMT(eDetails.eventsEnd, eDetails.eventEndTime, 'America/New_York');
        
          
        //console.log("[handleEventFormSubmit]");
        console.log("[EventFormModal=>OnSubmitEvent]: eDetails = " + JSON.stringify(eDetails));
        
        //console.log(convertedStart, convertedEnd);  // EST (Eastern Standard Time) or EDT (Eastern Daylight Time)

        

        //console.log('[TEST EventFormModal] ' + moment(`${eDetails.eventsStart} ${eDetails.eventStartTime}`, "%Y-%m-%d %H:%M").toString())
        // console.log('[TEST EventFormModal eDetails] ' + `${eDetails.eventsStart} ${eDetails.eventStartTime}`)
        // console.log('[TEST EventFormModal Now] ' + moment.now().toString())
        // console.log('[TEST EventFormModal Now F] ' + moment(moment.now()).format("YYYY-MM-DD HH:mm").toString())
        // console.log('[TEST EventFormModal eDetails F] ' + moment(`${eDetails.eventsStart} ${eDetails.eventStartTime}`).format("YYYY-MM-DD HH:mm").toString())
        // console.log('[TEST EventFormModal eDetails F Z] ' + moment(`${eDetails.eventsStart} ${eDetails.eventStartTime}`).tz(locale).format("z").toString())
        // console.log('[TEST EventFormModal eDetails F Z2] ' + moment(`${eDetails.eventsStart} ${eDetails.eventStartTime}`).tz(locale).format("z"))


        //console.log('[TEST moment locale] ' + moment.tz.guess())

        const submitted_start_datetime = moment(`${eDetails.eventStartDateTime}`).tz(locale).format("YYYY-MM-DD HH:mm");
        const submitted_end_datetime = moment(`${eDetails.eventEndDateTime}`).tz(locale).format("YYYY-MM-DD HH:mm");

        const newReqBody =
        {
            start_datetime: submitted_start_datetime, 
            start_tz: moment.tz.guess(),
            end_datetime: submitted_end_datetime,
            end_tz: moment.tz.guess(),
            name: eDetails.name,
            info: eDetails.info,
            venue: eDetails.venue,
            website_url: eDetails.websiteUrl,
            slots: eDetails.slots, 
            lowest_table_number: 1,
            highest_table_number: eDetails.highestTableNumber,
            //session_lock: null
        };
          
        const newRequestOptions = {...requestOptions, body: JSON.stringify(newReqBody)};
        //console.log("newRequestOptions single event");
        console.log("[EventFormModal=>OnSubmitEvent]: newRequestOptions = " + JSON.stringify(newRequestOptions));
    
        return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event/create', newRequestOptions)
            .then(res => res.json())
            .then((res) => 
            {
                if (res.result && res.result === `success`) 
                {
                    props.onSubmitSuccessful();
                    return true;
                }
                else
                {
                    console.error('Backend Error in CreateEvent');
                    res.reason && console.error('Reason: ' + res.reason);
                    return false;
                }
            })
            .catch((reason) =>
            {
                console.error('Fetch Exception in CreateEvent')
                console.error('Reason: ' + reason)
                return false;
            })
    }






    const OnEditEvent = (newEvent : EventFullInfo) => 
    {
        const requestOptions =
        {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(newEvent)
        }
        console.log("[EventFormModal=>OnEditEvent]: newEvent = " + newEvent);
        console.log(newEvent);

        const newReqBody =
        {
            id: instance?.id,
            start_datetime: moment(newEvent.start_DateTime).format("YYYY-MM-DD HH:mm").toString(), 
            start_tz: moment.tz.guess(),
            end_datetime: moment(newEvent.end_DateTime).format("YYYY-MM-DD HH:mm").toString(),
            end_tz: moment.tz.guess(),
            name: newEvent.name,
            info: newEvent.info,
            venue: newEvent.venue,
            website_url: newEvent.website_URL,
            slots: newEvent.slots, 
            lowest_table_number: 1,
            highest_table_number: newEvent.highest_Table_Number,
            //session_lock: newEvent.session_lock ? new Date() : instance?.session_lock 
        };
        
        const newRequestOptions = {...requestOptions, body: JSON.stringify(newReqBody)};
        //console.log("newRequestOptions single event");
        console.log("[EventFormModal=>OnEditEvent]: newRequestOptions = " + newRequestOptions.toString());

        return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event', newRequestOptions)
            .then(res => res.json())
            .then((res) => {
                if (res.result && res.result === `success`) 
                {
                    props.onSubmitSuccessful();
                    return true;
                }
                else
                {
                    console.error('Backend Error in OnEditEvent');
                    res.reason && console.error('Reason: ' + res.reason);
                    return false;
                }
            })
            .catch((reason) =>
            {
                console.error('Fetch Exception in OnEditEvent')
                console.error('Reason: ' + reason)
                return false;
            })
    }




    const OnSubmitEventSeries = (requestBody: EventSeriesCreateProps) =>
    {
        const requestOptions =
        {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        }

        const newReqBody = 
        {
            locale: locale,
            eventStartDateTime: setTimeofDateTime(moment(requestBody.start_Date),  moment(requestBody.start_DateTime, 'HH:mm')).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
            eventEndDateTime: setTimeofDateTime(moment(requestBody.end_Date),  moment(requestBody.end_DateTime, 'HH:mm')).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
            eventsStart: requestBody.start_Date,
            eventsEnd: requestBody.end_Date,
            name: requestBody.name,
            info: requestBody.info,
            venue: requestBody.venue,
            website_url: requestBody.website_URL,
            slots: requestBody.slots, 
            lowestTableNumber: requestBody.lowest_Table_Number,
            highestTableNumber: requestBody.highest_Table_Number,
            recurrencePattern: requestBody.recurrencePattern,
            recurrenceSeperation: requestBody.recurrenceSeperation,
        };
          
        const newRequestOptions = {...requestOptions, body: JSON.stringify(newReqBody)};
        console.log("newRequestOptions event series");
        console.log(newRequestOptions.body);

        props.onSubmitSuccessful();
    
        return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event2/series/create', newRequestOptions)
            .then(res => res.json())
            .then((res) => 
            {
                if (res.result && res.result === `success`) 
                {
                    props.onSubmitSuccessful();
                    return true;
                }
                else
                {
                    console.error(`Backend Error in createEventSeries`);
                    res.reason && console.error(`Reason: ${res.reason}`);
                    return false;
                }
            })
            .catch((reason) =>
            {
                console.error('Fetch Exception in createEventSeries')
                console.error(`Reason: ${reason}`)
                return false;
            })
    }




    const OnEditEventSeries = (requestBody: EventSeriesProps) =>
    {
        const requestOptions =
        {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        }

        console.log(requestBody);

        if(requestBody.start_Date) 
        {
            const newReqBody = 
            {
                id: requestBody.id,
                locale: locale,
                eventStartDateTime: setTimeofDateTime(moment(requestBody.start_Date),  moment(requestBody.start_DateTime, 'HH:mm')).format('HH:mm'),
                eventEndDateTime:  setTimeofDateTime(moment(requestBody.end_Date),  moment(requestBody.end_DateTime, 'HH:mm')).format('HH:mm'),
                eventsStart: requestBody.start_Date,
                eventsEnd: requestBody.end_Date,
                name: requestBody.name,
                info: requestBody.info,
                venue: requestBody.venue,
                website_url: requestBody.website_URL,
                slots: requestBody.slots, 
                lowestTableNumber: 1,
                highestTableNumber: requestBody.highest_Table_Number,
                recurrencePattern: requestBody.recurrencePattern,
                recurrenceSeperation: requestBody.recurrenceSeperation,
            };
            
            const newRequestOptions = {...requestOptions, body: JSON.stringify(newReqBody)};
            console.log("newRequestOptions event series");
            console.log(newRequestOptions.body);

            props.onSubmitSuccessful();
        
            return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event2/series?id=' + requestBody.id.toString(), newRequestOptions)
                .then(res => res.json())
                .then((res) => 
                {
                    if (res.result && res.result === `success`) 
                    {
                        props.onSubmitSuccessful();
                        return true;
                    }
                    else
                    {
                        console.error(`Backend Error in updateEventSeries`);
                        res.reason && console.error(`Reason: ${res.reason}`);
                        return false;
                    }
                })
                .catch((reason) =>
                {
                    console.error('Fetch Exception in updateEventSeries')
                    console.error(`Reason: ${reason}`)
                    return false;
                })
        }
    }


    


    //   const InternalOnSubmit = (requestBody:EventCreationDetails | EventSeriesProps | EventInfo) =>{
    //     // TODO: Timezone Conversion of request Body
    //     // EventCreation Details has 4 strings
    //     // Event Series Props has 4 Dates
    //     // Event info has 2 separate
        
    //     const requestOptions = {
    //       method: 'POST',
    //       headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
    //       body: JSON.stringify(requestBody)
    //     }

    //     console.log(requestBody);
    //     //Convert from local to GMT
    //     const eDetails = requestBody as EventCreationDetails
    //     const convertedStart = localToGMT(eDetails.eventsStart,eDetails.eventStartTime,`America/New_York`);
    //     const convertedEnd = localToGMT(eDetails.eventsEnd,eDetails.eventEndTime,`America/New_York`);
    //     console.log("[handleEventFormSubmit]");
    //     console.log(eDetails);
    //     console.log(convertedStart, convertedEnd);

    //     if (eDetails.recurrencePattern === "ONCE") 
    //     {
          
    //         const newReqBody = {
    //         start_time: `${convertedStart.date} ${convertedStart.time}`,
    //         end_time: `${convertedEnd.date} ${convertedEnd.time}`,
    //         name: eDetails.name,
    //         info: eDetails.info,
    //         venue: eDetails.venue,
    //         website_url: eDetails.websiteUrl,
    //         slots: eDetails.slots, 
    //         lowest_table_number: eDetails.lowestTableNumber,
    //         highest_table_number: eDetails.highestTableNumber,
    //       };
          
    //       const newRequestOptions = {...requestOptions, body: JSON.stringify(newReqBody)};
    //       console.log("newRequestOptions single event");
    //       console.log(newRequestOptions);

    //       return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event2/create', newRequestOptions)
    //         .then(res => res.json())
    //         .then((res) => {
    //           if (res.result && res.result === `success`) 
    //             {
    //                 setCreateEventDialogOpen(false)
    //                 fetchEvents(setEventsLoading, handleEventsLoaded, (err)=>console.error(err))
    //             return true;
    //           } else {
    //             console.error(`Backend Error in CreateEvent`);
    //             res.reason && console.error(`Reason: ${res.reason}`);
    //             return false;
    //           }
    //         })
    //         .catch((reason) => {
    //           console.error('Fetch Exception in CreateEvent')
    //         console.error(`Reason: ${reason}`)
    //             return false;
    //         })
    //     }
    //     else
    //     {
    //       // new event series
    //       const newReqBody = {
    //         timezone: timeZone,
    //         eventStartTime: `${convertedStart.time}`,
    //         eventEndTime: `${convertedEnd.time}`,
    //         eventsStart: `${convertedStart.date}`,
    //         eventsEnd: `${convertedEnd.date}`,
    //         name: eDetails.name,
    //         info: eDetails.info,
    //         venue: eDetails.venue,
    //         website_url: eDetails.websiteUrl,
    //         slots: eDetails.slots, 
    //         lowestTableNumber: eDetails.lowestTableNumber,
    //         highestTableNumber: eDetails.highestTableNumber,
    //         recurrencePattern: eDetails.recurrencePattern,
    //         recurrenceSeperation: eDetails.recurrenceSeperation,
    //       };
    //       const newRequestOptions = {...requestOptions, body: JSON.stringify(newReqBody)};
    //       console.log("newRequestOptions event series");
    //       console.log(newRequestOptions);

    //       return fetch(process.env.REACT_APP_REFLEBULA + '/a1/tga/event2/series/create', newRequestOptions)
    //         .then(res => res.json())
    //         .then((res) => {
    //           if (res.result && res.result === `success`) {
    //             setCreateEventDialogOpen(false)
    //             fetchEvents(setEventsLoading, handleEventsLoaded, (err)=>console.error(err))
    //             return true;
    //           } else {
    //             console.error(`Backend Error in createEventSeries`);
    //             res.reason && console.error(`Reason: ${res.reason}`);
    //             return false;
    //           }
    //         })
    //         .catch((reason) => {
    //           console.error('Fetch Exception in createEventSeries')
    //         console.error(`Reason: ${reason}`)
    //             return false;
    //         })
    //     }
    //   }



    const localOnSubmit = (fields: FieldValues) =>
    {
        /* transforms field values to EventSeriesProps or
            EventCreationSchema before calling props.onSubmit */
        console.log("[localOnSubmit]");
        console.log(`isEditingSeries ${isEditingSeries}`);
        console.log(series);
        console.log(instance);

        if (isEditingSeries && !series)
        {
            console.log(fields.eventStartTime);
            // Editing existing event series, submit EventSeriesProps
            //First edit event
            OnSubmitEventSeries({
            info: fields.info,
            name: fields.name,
            slots: Number(fields.slots),
            start_Date: fields.eventsStart,
            end_Date: fields.eventsEnd,
            start_DateTime: fields.eventStartTime,
            end_DateTime: fields.eventEndTime,
            recurrencePattern: fields.recurrencePattern,
            recurrenceSeperation: fields.recurrenceSeperation,
            venue: fields.venueOption.value.id,
            website_URL: fields.websiteUrl,
            lowest_Table_Number: Number(fields.lowestTableNumber), // To be implemented
            highest_Table_Number: Number(fields.highestTableNumber), // To be implemented
            } as EventSeriesCreateProps)
        }
        else if (!isEditingSeries && instance)
        {
            // Editing instance event, submit EventInfo
            OnEditEvent({
            id: instance.id,
            name: fields.name,
            venue: fields.venueOption.value.id,
            start_DateTime: fields.instanceStartDateTime,
            end_DateTime: fields.instanceEndDateTime,
            info: fields.info,
            website_URL: fields.websiteUrl,
            slots: Number(fields.slots),
            lowest_Table_Number: Number(fields.lowestTableNumber),
            highest_Table_Number: Number(fields.highestTableNumber), // To be implemented
            owner: instance.owner,
            series_ID: instance.series_ID,
            //session_lock: fields.session_lock
            } as EventFullInfo)
        }
        else if (isEditingSeries && series)
        {
            // Editing instance event, submit EventInfo
            OnEditEventSeries({
            highest_Table_Number: Number(fields.highestTableNumber), // To be implemented
            id: series.id,
            info: fields.info,
            lowest_Table_Number: 1,
            name: fields.name,
            owner: series.owner,
            slots: Number(fields.slots),
            venue: fields.venueOption.value.id,
            website_URL: fields.websiteUrl,
            start_Date: fields.eventsStart,
            end_Date: fields.eventsEnd,
            start_DateTime: fields.eventStartTime,
            end_DateTime: fields.eventEndTime,
            recurrencePattern: fields.recurrencePattern,
            recurrenceSeperation: fields.recurrenceSeperation
            } as EventSeriesProps)
        }
        else  
        {
            if(fields.recurrencePattern === 'ONCE')
            {
                console.log('EventForm.localOnSubmit: reccurence pattern is ONCE')
            }
            else
            {
                console.log('EventForm.localOnSubmit: reccurence pattern is not ONCE')
            }

            // Create new one-off event, submit EventCreationDetails
            OnSubmitEvent({
                info: fields.info,
                name: fields.name,
                slots: Number(fields.slots),
                eventsStart: fields.eventsStart.split("T")[0],
                eventsEnd: (fields.recurrencePattern === 'ONCE') ? fields.eventsStart.split("T")[0] : fields.eventsEnd.split("T")[0], // Set eventsEnd = eventsStart for non-recurring event
                eventStartDateTime: fields.instanceStartDateTime,
                eventEndDateTime: fields.instanceEndDateTime,
                recurrencePattern: fields.recurrencePattern,
                recurrenceSeperation: fields.recurrenceSeperation,
                venue: fields.venueOption.value.id,
                websiteUrl: fields.websiteUrl,
                lowestTableNumber: Number(fields.lowestTableNumber), // To be implemented
                highestTableNumber: Number(fields.highestTableNumber), // To be implemented
                rsvp: fields.rsvp
            } as EventCreationDetails)
        }

        //reset(defaultValues) We don't want to reset the form values in case the user wants to re-enter the panel.
    }





    const handleDeleteEvent = (id: number) => 
    {
        const requestOptions = 
        {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
        }

        return fetch(process.env.REACT_APP_REFLEBULA + `/a1/tga/event2/single?id=${id}`, requestOptions)
            .then(res => res.json())
            .then((res) => {
                if (res.result && res.result === `success`) {
                    //TODO: Add On Delete Successful
                    props.onSubmitSuccessful();
                    return true;
                } else {
                    console.error(`Backend Error in handleEventDelete`);
                    res.reason && console.error(`Reason: ${res.reason}`);
                    return false;
                }
            })
            .catch((reason) => {
                console.error('Fetch Exception in handleEventDelete')
                console.error(`Reason: ${reason}`)
                return false;
            })
    }





    const handleDeleteSeries = (id: number) => 
    {
        const requestOptions = 
        {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${props.authToken}`, 'Content-Type': 'application/json' },
        }

        return fetch(process.env.REACT_APP_REFLEBULA + `/a1/tga/event2/series?id=${id}`, requestOptions)
            .then(res => res.json())
            .then((res) => {
                if (res.result && res.result === `success`) {
                    //TODO: Add on Delete Successful
                    props.onSubmitSuccessful();
                    return true;
                } else {
                    console.error(`Backend Error in handleEventDelete`);
                    res.reason && console.error(`Reason: ${res.reason}`);
                    return false;
                }
            })
            .catch((reason) => {
                console.error('Fetch Exception in handleEventDelete')
                console.error(`Reason: ${reason}`)
                return false;
            })
    }






    const localOnDelete = (event: EventFullInfo | EventSeriesProps) => 
    {
      console.log(series);
      if(isEditingSeries && series) 
      {
          handleDeleteSeries(series.id)
      } else 
      {
          handleDeleteEvent(event.id)
      }
    }





    const localHandleRSVPToggle =()=>
    {
        if(instance){
            onRSVPToggle(instance.id).then(()=>
            (
                loadEventAttendees()
            ))
        } 
        else
        {
            console.error('EventForm.localHandleRSVPToggle: event instance not found')
        }
    }





    if(isLoading)
    {
        return (
            <div style={{display:'flex', alignItems:'center', justifyContent:'center', height:'100%', width:'100%'}}>
                <MoonLoader/>
            </div>
        )
    }
  




  return (
    <form onSubmit={handleSubmit(localOnSubmit)} className={containerClassname || 'event-form'}>

      <div className='event-form-first-row-container'>
        {event && !readonly ?
          <div>
            {
              <Select styles={{control: (baseStyles, state) => ({
                  ...baseStyles,
                  flexGrow: 1,
                  width: 250,
                  marginRight: 8
                  }),
                }}
            
                defaultValue={{ label: 'Editing event series for', value: 'true' }}
            
                options={isEditingSeriesSelectOptions}
            
                onChange={(o:any)=>handleChangeBetweenEditingInstanceOrSeries(o)}
            
                value={event && isEditingSeries ? isEditingSeriesSelectOptions[0] : isEditingSeriesSelectOptions[1]}
              /> 
            }
          </div>
          :
          !event && <h4 className='controls-row' style={{ marginRight: 8 }}>Creating new event</h4>
        }

        {
          !readonly ? 
            <input style={{ textAlign: 'center', width: '75%', height: 30 }} className='event-form-item' type="text" placeholder="Event Name"{...register("name", {required: 'Event name is required'})}/>
          :
            <h3 className='controls-row read-only-field' style={{ marginRight: 8 }}>{event?.name}</h3>
        }

        <ErrorMessage errors={errors} name="name" render={({ message }) => <p className='helper-text'>{message}</p>}/>
      </div>


      <div className='event-form-second-row-container'>
        {
          (isEditingSeries && !event) &&
          <div id='event-form-time-controls-for-series' className='controls-row'>
            <h4 style={{ textAlign: 'center' }}>from</h4>

            <Controller control={control} name='eventStartTime'render={
              ({ field:{onChange, value} }) =>
              (
                <TimePicker locale="en-US" clockIcon={null} onChange={e => e ? onChange(e) : undefined} value={value} />
              )}
            />

            <h4 style={{ textAlign: 'center' }}>to</h4>

            <Controller control={control} name='eventEndTime' render={
              ({ field:{value, onChange} }) =>
              (
                <TimePicker locale="en-US" clockIcon={null} onChange={e => e ? onChange(e) : undefined} value={value} />
              )}
            />

            <h4 style={{ textAlign: 'center' }}>{isEditingSeries ? "starting on" : "on"}</h4>

            <Controller control={control} name='eventsStart' render={
              ({ field:{value, onChange}}) =>
              (
                <DatePicker locale="en-US" onChange={e=> e ? onChange((e as Date).toISOString()) : undefined} value={value} />
              )}
            />
          </div>
        }

        {
          (!isEditingSeries && !event) &&
          <div id='event-form-time-controls-for-instance' className='controls-row'>
            <h4 style={{ textAlign: 'center' }}>from</h4>

            {
              !readonly ?
                <Controller control={control} name='instanceStartDateTime' render={
                  ({ field:{value, onChange}}) =>
                  (
                    <DateTimePicker locale="en-US" disableClock={true} onChange={e => e ? onChange(e) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{getValues('instanceStartDateTime').toLocaleString()}</h4>
            }
            
            <h4 style={{ textAlign: 'center' }}>to</h4>
            
            {
              !readonly ?
                <Controller control={control} name='instanceEndDateTime' render={
                  ({ field:{value, onChange}}) =>
                  (
                    <DateTimePicker locale="en-US" disableClock={true} onChange={e => e ? onChange(e) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{getValues('instanceEndDateTime').toLocaleString()}</h4>
            }
          </div>
        }

        {
          (isEditingSeries && event) &&
          <div id='event-form-time-controls-for-series' className='controls-row'>
            <h4 style={{ textAlign: 'center' }}>from</h4>

            {
              !readonly ?
                <Controller control={control} name='eventStartTime'render={
                  ({ field:{onChange, value} }) =>
                  (
                    <TimePicker locale="en-US" clockIcon={null} onChange={e => e ? onChange(e) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{(event as EventSeriesProps)?.start_DateTime?.toLocaleTimeString()}</h4>
            }

            <h4 style={{ textAlign: 'center' }}>to</h4>

            {
              !readonly ?
                <Controller control={control} name='eventEndTime' render={
                  ({ field:{value, onChange} }) =>
                  (
                    <TimePicker locale="en-US" clockIcon={null} onChange={e => e ? onChange(e) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{(event as EventSeriesProps)?.end_DateTime?.toLocaleTimeString()}</h4>
            }

            <h4 style={{ textAlign: 'center' }}>{isEditingSeries ? "starting on" : "on"}</h4>

            {
              !readonly ?
                <Controller control={control} name='eventsStart' render={
                  ({ field:{value, onChange}}) =>
                  (
                    <DatePicker locale="en-US" onChange={e=> e ? onChange((e as Date).toISOString()) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{(event as EventSeriesProps)?.start_Date?.toDateString()}</h4>
            }
          </div>
        }

        {
          (!isEditingSeries && event) &&
          <div id='event-form-time-controls-for-instance' className='controls-row'>
            <h4 style={{ textAlign: 'center' }}>from</h4>

            {
              !readonly ?
                <Controller control={control} name='instanceStartDateTime' render={
                  ({ field:{value, onChange}}) =>
                  (
                    <DateTimePicker locale="en-US" onChange={e => e ? onChange(e) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{getValues('instanceStartDateTime').toLocaleString()}</h4>
            }
            
            <h4 style={{ textAlign: 'center' }}>to</h4>
            
            {
              !readonly ?
                <Controller control={control} name='instanceEndDateTime' render={
                  ({ field:{value, onChange}}) =>
                  (
                    <DateTimePicker locale="en-US" onChange={e => e ? onChange(e) : undefined} value={value} />
                  )}
                />
              :
                <h4 className='read-only-field'>{getValues('instanceEndDateTime').toLocaleString()}</h4>
            }
          </div>
        }
      </div>


      <div className='event-form-third-row-container'>
        <div id='second-row-controls-series' className='controls-row'>
          {
            (isEditingSeries || !event) &&
            <div className='controls-row'>
              <h4 style={{ textAlign: 'center' }}>occurring</h4>

              <Controller control={control} name='recurrencePreset' render={
              ({ field:{onChange, value} }) =>
              {
                  return (
                  <Select options={recurrenceSelectOptions}
                      defaultValue={{ label: 'One time only', value: {recurrencePattern:'ONCE', recurrenceSeperation:0}}}
                      onChange={(e)=>{onChange(e); handleRecurrencePatternChange(e)}}
                      value={value}
                  />
                  )
              }}
              />
            </div>
          }

          {
              (isEditingSeries && isRecurring) &&
              <div className='controls-row'>
              <h4 style={{ textAlign: 'center' }}>until</h4>

              <Controller control={control} name='eventsEnd' render={
                  ({ field:{onChange, value} }) =>
                  (
                  <DatePicker locale="en-US" onChange={e=>e ? onChange((e as Date).toISOString()) : undefined} value={value} />
                  )}
              />
              </div>
          }

        </div>

        <div className='controls-row' style={{ flexGrow: 1 }}>
          <h4>at</h4>
          {
            !readonly ?
              <Controller rules={{ required: true }} control={control} name='venueOption' render={
                ({ field:{value, onChange} }) =>
                {
                  return(<Select classNames={{input:()=>('react-select-input'), control:()=>('react-select-control'), container:()=>('react-select-container')}}
                            value={value} placeholder="Select a venue..." blurInputOnSelect captureMenuScroll id='venue-select'
                            onChange={(o:{label:string, value:VenueDetails})=>{onChange(o); handleVenueSelect(o)}}
                            options={venueOptions}
                          />
                  )
                }}
              /> 
            :
              <h4 className='read-only-field'>{(event && event.name === "Titan Buster") ? "Private Venue" : selectedVenue?.name}</h4>
          }
        </div>
      </div>


      <div className='event-form-fields'>
        {
          !readonly ?
            <textarea style={{ flexGrow: 1 }} className='event-form-item' placeholder='Introduction and Description' {...register("info", {required: false})}/>
          :
            <p className="read-only-field" style={{height:'100%', margin:0}}>{getValues('info')}</p>
        }
        
        <label>{`Hosted By: ${userDetails?.user_name}`}</label>

        <label>
          Max Participants:
          {
            !readonly ?
              <div style={{ display: 'inline-block' }}>
                <input type="number" min="1" max="100" className='event-form-item' style={{ textAlign: 'center', width: 60 }} {...register("slots", {})}>
                </input>
              </div>
            :
              <span className='read-only-field'>{getValues('slots')}</span>
          }
        </label>

        <label>
          Lowest Table Number:
          {
            !readonly ?
              <div style={{ display: 'inline-block' }}>
                <input type="number" min="1" max="25" className='event-form-item' style={{ textAlign: 'center', width: 60 }} {...register("lowestTableNumber", {})}>
                </input>
              </div>
            :
              <span className='read-only-field'>{getValues('lowestTableNumber')}</span>
          }
        </label>

        <label>
          Highest Table Number:
          {
            !readonly ?
              <div style={{ display: 'inline-block' }}>
                <input type="number" min="1" max="25" className='event-form-item' style={{ textAlign: 'center', width: 60 }} {...register("highestTableNumber", {})}>
                </input>
              </div>
            :
              <span className='read-only-field'>{getValues('highestTableNumber')}</span>
          }
        </label>

        {
          !isEditingSeries &&
          <div>
            <p>
              Attendees: {theRSVPString}
            </p>
          </div>
        }
      </div>


      <div className='event-form-venue'>
        {
          //TODO: Remove Hardcoded reliance on Titan Buster
          !selectedVenue || (selectedVenue?.private) || (event && event.name === "Titan Buster") ?
            <div className='event-form-venue-placeholder'>
              <img className='event-form-venue-placeholder-image' src={privateVenueMapPlaceholder} />
              {
                selectedVenue || getValues('venueOption') ?
                  <h4 style={{ textAlign: 'center', margin: '.25em', whiteSpace: 'pre-wrap' }}>{"This is a private venue. \n Please message event host for address."}</h4>
                :
                  <h4 style={{ textAlign: 'center', margin: '.25em', whiteSpace: 'pre-wrap' }}>{"No venue selected. Please select a venue."}</h4>
              }
            </div>
          :
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
              <h4 style={{ textAlign: 'center' }}>{selectedVenue?.agg_address}</h4>
              <VenueMap containerClassName='event-form-venue-map' venue={selectedVenue} />
            </div>
        }
      </div>


      {
        !readonly ?
          <div className='event-form-controls'>
            {
              !deleteConfirmDisplay &&
              <div className='event-form-controls'>

                {
                  (event?.id || series?.id) &&
                  <div>
                    <button type='button' className='event-form-button' onClick={() => setDeleteConfirmDisplay(true)}>
                      {isEditingSeries ? "Delete Event Series" : "Delete Event"}
                    </button>
                  </div>
                }

                <button type='button' value='Cancel' className='event-form-button' onClick={()=>{!props.noReset && reset(defaultValues); onCancel()}}>
                  Cancel
                </button>

                <button disabled={!isValid} style={{ backgroundColor: isValid ? 'lightgrey' : 'darkgrey'}} value='Submit' className='event-form-button' type="submit">
                  {isValid ? 'Submit' : <abbr title='All fields are required'>Submit</abbr>}
                </button>
              </div>
            }

            {
              deleteConfirmDisplay &&
              <div className='event-form-controls'>
                <p>Are you sure you want to delete?</p>

                <button type='button' className='event-form-button' style={{ backgroundColor: '#ae2515' , color: 'white' }} onClick={()=>event ? localOnDelete(event):console.warn('onDelete missing event or handler.')}>
                  Yes
                </button>

                <button type='button' className='event-form-button'onClick={()=>setDeleteConfirmDisplay(false)}>
                  No
                </button>
              </div>
            }
          </div>
        :
          <div className='event-form-controls'>
            {
              loggedInUser && userDetails?.user_name === event?.owner &&
              <button type='button' className='event-form-button' onClick={ onRequestEdit ? onRequestEdit : ()=>console.warn('EventForm onRequestEdit called, but not defined')}>
                Edit
              </button>
            }

            {
              loggedInUser && !props.disableRsvp &&
              <button type='button' className='event-form-button' onClick={localHandleRSVPToggle}>
                {userDetails?.user_name && theRSVPArray?.includes(userDetails.user_name) ? 'Cancel RSVP' : 'RSVP'}
              </button>
            }
          </div>
      }
    </form>
  )
}

export default EventFormModal

/*
            {
              !readonly ?
                    (<label>
                      <input type="checkbox"
                        {...register('session_lock',{})}/> Prevent Sessions from being Created/Edited any further
                    </label>)
              :
                <h4 className='read-only-field'>{(event as EventSeriesProps)?.start_Date?.toDateString()}</h4>
            }

*/